import { Component, createRef } from "react"

/* Livekit */
import * as LiveKit from "livekit-client"


/* Class Studio Video */
class StudioVideo extends Component {

    constructor() {
        super()

        this._video = createRef()
    }

    componentDidMount = async () => {

        /* Fields */
        const { socketURL, token } = this.props

        /* Check */
        if (!socketURL || !token) {
            return
        }

        /* Create Room */
        const room = new LiveKit.Room({ adaptiveStream: true, dynacast: true })
        this._room = room

        /* On Connect */
        room.on(LiveKit.RoomEvent.TrackSubscribed, (track) => {

            /* Get Video */
            const video = this._video.current

            /* Check Video */
            if (!video) {
                return
            }

            video.autoplay = true
            video.playsInline = true
            video.volume = 0
            video.muted = true

            /* Add Video */
            if (track.kind === "video") {
                track.attach(video)
            }

            /* Add Audio */
            if (track.kind === "audio") {
                track.attach(video)
            }

        })


        /* Connect */
        await room.connect(socketURL, token)

        /* Set Parameters */
        room.localParticipant.setMicrophoneEnabled(false)
        room.localParticipant.setCameraEnabled(false)

    }

    componentWillUnmount = () => {

        /* Check Room */
        if (this._room) {
            this._room.disconnect()
            this._room = null
        }

        /* Check Video */
        if (this._video.current) {
            this._video.current.srcObject = null
        }

    }

    render = () => {
        return <video ref={this._video} controls autoPlay muted />
    }
}

export default StudioVideo